import { useRef, useContext, useEffect, useState } from 'react';

import styles from './PreviewPdfFileComponent.module.css'

import { GlobalContext } from '../../../contexts/globalContext';

import CustomMultitouchComponent from '../../../files/CustomMultitouchComponent';

import { GetMaxZIndex } from '../../../utils/UtilitaryFunctions';

import { PdfComponent } from 'use-gesture-pack';


const PreviewPdfFileComponent = ({ file, setTopicFilesOpened }) => {

    const { appHeight, appWidth, setAlertMessage } = useContext(GlobalContext);

    const ref = useRef(null);
    const mtRef = useRef(null);
    const pdfRef = useRef();
    const isOpenCanvasRef = useRef(false);

    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    const containerStyle = {
        width: `${isVisible ? width - 2 : 0}px`,
        height: `${isVisible ? height - 2 : 0}px`,
        padding: `${isVisible ? '0px' : '0px'}`,
        backdropFilter: `${isVisible ? 'blur(10px)' : ''}`,
        backgroundColor: `${isVisible ? 'rgba(0, 0, 0, 0.3)' : 'transparent'}`,
    };

    const options = {
        appWidth,
        appHeight,
        maxScale: appHeight / 600,
        minScale: 0.5
    }

    const onDocumentLoaded = (data) => {
        setIsVisible(true)
        setWidth(data.width);
        setHeight(data.height);
    }

    useEffect(() => {
        fetch(process.env.REACT_APP_CMS_URL + file.path, { method: "HEAD" })
            .then((res) => {
                if (res.ok) {
                    setIsVisible(true);
                    mtRef.current.style.zIndex = GetMaxZIndex() + 1;
                }
            })
            .catch(() => {
                setAlertMessage({ type: "ERROR", message: "The file is no longer at the address provided." });
                onMinScaleReached()
            })
        
    }, [])

    const onMinScaleReached = () => {
        setTopicFilesOpened(files => files.filter(a => a.uid !== file.uid));
    }

    const onSwipe = (direction) => {
        pdfRef.current.changePage(direction);
    }


    return (
        <CustomMultitouchComponent ref={mtRef} dragGesture={false} x={file.x + 70} y={file.y + 35} width={isVisible ? width : 60} height={isVisible ? height : 75}
            onSwipe={onSwipe} onMinScaleReached={onMinScaleReached} options={options} isOpenCanvasRef={isOpenCanvasRef} dragGestureMouse={true} 
            dragBox={{ x: 0, y: 0, width: appWidth, height: appHeight }}>
            <div ref={ref} style={containerStyle} className={styles.touch_component}>
                <PdfComponent ref={pdfRef} src={process.env.REACT_APP_CMS_URL + file.path} onDocumentLoaded={onDocumentLoaded} />
            </div>
        </CustomMultitouchComponent>
    );
}

export default PreviewPdfFileComponent;